<script lang="ts">
  import { fade } from "svelte/transition";
  import { DEFAULT_FADE_TRANSITION } from "./transitions";
  import type { ModalPartAttributes } from "./createModal";

  interface $$Props extends ModalPartAttributes {}
</script>

<div {...$$restProps} class="underlay" transition:fade|global={DEFAULT_FADE_TRANSITION} />

<style>
  div {
    background-color: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 50;
    overflow: hidden;
  }
</style>
